























import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class NicIntervensiChecklist extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: Record<string, boolean>;
  @Prop({ default: false }) readonly disabled!: boolean;

  localValue: Record<string, boolean> = {};

  nicItems = [
    { key: "reduksi_ansietas", label: "Reduksi Ansietas (I.09134)" },
    { key: "manajemen_nyeri", label: "Manajemen Nyeri (I.08238)" },
    { key: "pemberian_anestesi", label: "Pemberian Anestesi (I.08244)" },
    { key: "pengontrolan_infeksi_intra_operatif", label: "Pengontrolan Infeksi Intra Operatif (I.14552)" },
    { key: "pencegahan_cedera", label: "Pencegahan Cedera (I.14537)" },
    { key: "pencegahan_perdarahan", label: "Pencegahan Perdarahan (D.0012)" },
    { key: "manajemen_hipotermi", label: "Manajemen Hipotermi (I.14507)" },
    { key: "pencegahan_jatuh", label: "Pencegahan Jatuh (I.14540)" },
    { key: "manajemen_resusitasi_cairan", label: "Manajemen Resusitasi Cairan (I.14507)" },
    { key: "manajemen_sedasi", label: "Manajemen Sedasi (I.08239)" },
    { key: "manajemen_syok", label: "Manajemen Syok (I.02048)" }
  ];

  mounted() {
    this.localValue = { ...this.value };
  }

  @Watch("value", { deep: true })
  onValueChange(val) {
    this.localValue = { ...val };
  }

  emitChange() {
    this.$emit("input", { ...this.localValue });
  }
}
